module.exports = __webpack_public_path__ + "static/media/stedelijk.7be74df0.jpg";